import type { RootState } from '@core/Store'

export const selectIsBetLoopAccessRestricted = ({ appConfig }: RootState) =>
  appConfig.betLoopAccessErrorStatus === 'banned'

export const selectIsBetLoopAccessUnavailable = ({ appConfig }: RootState) =>
  appConfig.betLoopAccessErrorStatus === 'unavailable'
